import ReusableForm from "../../unity-ui-common/Components/ReForm";
import ReInput from "../../unity-ui-common/Components/ReFormFields/ReInput";
import ReUpload from "../../unity-ui-common/Components/ReFormFields/ReUpload";
import ReModal from "../../unity-ui-common/Components/ReModal";
import KnowledgeBase from "../../Components/KnowledgeBase/KnowledgeBase";
import FAQ from "../../Components/FAQ/FAQ";
import { useState } from "react";
import { SmallSupportCard, SupportIdGenerator } from "../../Components";
import {
  MailOutlined,
  BookOutlined,
  CloseOutlined,
  BulbOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { ReNotification } from "../../unity-ui-common/Components/ReNotification";
import { Card, Form, Button, Input, Space } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.min.js";
import * as styles from "./SupportStyles";
import { file } from "../../API/File";
import { notification } from "../../API/Notifications";

function Support() {
  const [form] = Form.useForm();
  const [supportId, setSupportId] = useState<string>("");
  const [showForm, setShowForm] = useState(false);
  const [fileList, setFileList] = useState<any[]>([]);
  const [attachmentUploading, setAttachmentUploading] =
    useState<boolean>(false);
  const [attacmentData, setAttacmentData] = useState<any>([]);
  const [showKnowledgeBase, setShowKnowledgeBase] = useState<boolean>(false);
  const [showFAQS, setShowFAQS] = useState<boolean>(false);
  const [showPdfModal, setShowPdfModal] = useState<boolean>(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [scale, setScale] = useState<number>(1.0);
  const [pdfError, setPdfError] = useState<string | null>(null);
  const handleBeforeUpload = async (fileObj: any) => {
    setAttachmentUploading(true);
    const filenameArr = fileObj["name"].split(".");
    const file_type = filenameArr[filenameArr.length - 1];

    const res = await file.getUrl(file_type);
    const fileName = filenameArr[0];

    setFileList([...fileList, fileObj]);
    await file.remoteUploadFile(res.url, fileObj);

    setAttacmentData([
      ...attacmentData,
      {
        fileUID: fileObj.uid,
        id: res.id,
        filename: fileName,
        file_type,
      },
    ]);

    setAttachmentUploading(false);
    return true;
  };

  const handleSubmit = async (values: any) => {
    const payload = {
      subject: values.subject || "",
      text: values.text + ` Support ID: ${supportId.toLocaleUpperCase()}` || "",
      attachmentList: attacmentData || [],
    };
    const res = await notification.sendEmail(
      "send-multi-attachment-email",
      payload
    );
    if (res?.status) {
      form.resetFields();
      setAttacmentData([]);
      setFileList([]);
      setShowForm(false);
      ReNotification({
        description: `Email Sent Successfully`,
        placement: "bottomLeft",
        type: "success",
      });
    } else {
      ReNotification({
        description: `Unable to Send Email`,
        placement: "bottomLeft",
        type: "error",
      });
    }
  };
  const toggleFormVisibility = () => {
    setShowForm((prevValue) => !prevValue);
    form.resetFields();
    setAttacmentData([]);
    setFileList([]);
  };

  pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

  // Hand pdf.js the same-origin URL, not a blob: URL - the server's
  // Content-Security-Policy (connect-src 'self') blocks pdf.js from reading blob: URLs.
  const openPdfModal = (fileName: string) => {
    setPdfError(null);
    setPdfUrl(`/Assets/${fileName}`);
    setPageNumber(1);
    setNumPages(0);
    setScale(1);
    setShowPdfModal(true);
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setPdfUrl(null);
    setNumPages(0);
    setPageNumber(1);
    setScale(1);
    setPdfError(null);
  };

  return (
    <styles.Container>
      <styles.Left>
        <SupportIdGenerator supportId={supportId} setSupportId={setSupportId} />
        <div className="smallCards">
          <SmallSupportCard
            title="Contact via Email"
            buttonTitle="Contact us"
            onClick={toggleFormVisibility}
            Icon={<MailOutlined style={{ fontSize: "2rem" }} />}
          />
          <SmallSupportCard
            title="Learn from Knowledge Base"
            buttonTitle="Visit Knowledge Base"
            Icon={<BookOutlined style={{ fontSize: "2rem" }} />}
            onClick={() => setShowKnowledgeBase(!showKnowledgeBase)}
          />
          <SmallSupportCard
            title="FAQ"
            buttonTitle="Open FAQs"
            Icon={<BulbOutlined style={{ fontSize: "2rem" }} />}
            onClick={() => setShowFAQS(!showKnowledgeBase)}
          />
          <ReModal
            width={900}
            visibility={showFAQS}
            onCancel={() => setShowFAQS(false)}
            children={<FAQ />}
            title={"Frequently Asked Questions (FAQs)"}
            footer={null}
          />
          <ReModal
            visibility={showKnowledgeBase}
            onCancel={() => setShowKnowledgeBase(false)}
            children={<KnowledgeBase onManualOpen={openPdfModal} />}
            title={"Knowledge Base"}
            footer={null}
          />
          <ReModal
            visibility={showPdfModal}
            onCancel={closePdfModal}
            title={null}
            closable={false}
            footer={null}
            width={window.innerWidth}
            height={window.innerHeight}
            centered={false}
            style={{ top: 0, padding: 0 }}
            bodyStyle={{ maxHeight: `${window.innerHeight}px`, overflow: "hidden" }}
          >
            <div
              className="pdf-viewer-container"
              style={{ position: "relative", height: window.innerHeight + "px" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <div
                className="pdf-toolbar"
                style={{ position: "absolute", top: 8, right: 8, zIndex: 10 }}
              >
                <Space>
                  <Button
                    size="small"
                    onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
                    disabled={pageNumber <= 1}
                  >
                    Prev
                  </Button>
                  <Input
                    size="small"
                    style={{ width: 72, textAlign: "center" }}
                    value={`${pageNumber} / ${numPages || "-"}`}
                    onChange={(e) => {
                      const val = parseInt(e.target.value.split(" ")[0]);
                      if (!isNaN(val) && val >= 1 && val <= numPages) setPageNumber(val);
                    }}
                  />
                  <Button
                    size="small"
                    onClick={() => setPageNumber((p) => Math.min(numPages || p, p + 1))}
                    disabled={pageNumber >= numPages}
                  >
                    Next
                  </Button>
                  <Button size="small" onClick={() => setScale((s) => Math.max(0.5, s - 0.25))}>
                    -
                  </Button>
                  <Button size="small" onClick={() => setScale((s) => Math.min(3, s + 0.25))}>
                    +
                  </Button>
                </Space>
              </div>

              <div
                className="pdf-canvas-area"
                style={{ width: "100%", height: "100%", overflow: "auto", position: "relative" }}
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              >
                {pdfError && <div className="pdf-error">{pdfError}</div>}
                {!pdfError && pdfUrl && (
                  <Document
                    file={pdfUrl}
                    loading={<div className="pdf-loading">Loading...</div>}
                    onLoadSuccess={({ numPages: n }: any) => setNumPages(n)}
                    onLoadError={() => setPdfError("Unable to render document.")}
                  >
                    <div style={{ display: "flex", justifyContent: "center", padding: 12 }}>
                      <Page pageNumber={pageNumber} scale={scale} renderTextLayer={false} renderAnnotationLayer={false} />
                    </div>
                  </Document>
                )}
              </div>

              <Button
                className="pdf-close-btn"
                type="primary"
                onClick={closePdfModal}
                style={{ position: "absolute", top: 10, left: 10, zIndex: 9999 }}
              >
                <ArrowLeftOutlined />
                Back
              </Button>
            </div>
          </ReModal>
        </div>
      </styles.Left>
      <styles.Right>
        {showForm ? (
          <Card className="contact-us-form" title={`Contact via Email`}>
            <div className="close" onClick={toggleFormVisibility} onKeyDown={() => {}}>
              <CloseOutlined />
            </div>
            <ReusableForm
              formInstance={form}
              onSubmit={handleSubmit}
              submitBtnText="Send Email"
              submitBtn
            >
              <ReInput label="Subject" name="subject" type="simple" required />
              <ReInput
                label="Description"
                name="text"
                type="textArea"
                textAreaOptions={{
                  rowSize: 7,
                }}
                required
              />
              <div className="upload-btn">
                <ReUpload
                  label="Upload Screen Shots"
                  name="screenshot"
                  BtnTitle="Click to Upload"
                  onBeforeUpload={handleBeforeUpload}
                  onRemove={(fileObj: any) => {
                    const index = fileList.indexOf(fileObj);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    setFileList(newFileList);
                    const index2 = attacmentData.indexOf(fileObj);
                    const newFileList2 = attacmentData.slice();
                    newFileList2.splice(index2, 1);
                    setAttacmentData(newFileList2);
                  }}
                  fileList={fileList}
                  disable={attachmentUploading}
                  fileListMaxCount={20}
                  errorMessage={"Error"}
                  accept={".png,.jpg,.jpeg"}
                />
              </div>
            </ReusableForm>
          </Card>
        ) : (
          <></>
        )}
      </styles.Right>
    </styles.Container>
  );
}

export default Support;
